import type { AnyAction } from 'redux'

import type { RootState } from '~publish/legacy/store'

import { actionTypes } from './actions'

const eventQueue: AnyAction[] = []

export default ({ getState }: { getState: () => RootState }) =>
  (next: (action: AnyAction) => unknown) =>
  (action: AnyAction): void => {
    const { analytics } = window

    next(action)
    const state = getState()
    switch (action.type) {
      case actionTypes.INIT:
        if (analytics) {
          analytics.identify(action.userId, action.payload)
        }
        break

      // TODO: Still used for tracking hashtag manager, instagram user tags, and possibly analyze report clicks - to be removed when hashtag manager is migrated
      case actionTypes.TRACK_EVENT: {
        const orgId = state.organizations.selected?.id

        if (orgId) {
          if (analytics) {
            analytics.track(action.eventName, {
              ...action.payload,
              product: window.PRODUCT_TRACKING_KEY,
              clientName: window.CLIENT_NAME,
              organizationId: orgId,
            })
          }
        } else {
          eventQueue.push(action)
        }

        break
      }
      default:
        break
    }
  }
